import React from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { z, ZodType } from 'zod';

import { useCustomForm } from '@/components/shared/hooks/useCustomForm';
import es from '@/config/languages/es';

export interface FormWrapperProps<T extends ZodType> {
  children?: React.ReactElement;
  formSchema: (t: (textId: keyof typeof es) => string) => T;
  defaultValues?: z.infer<T>;
  formMethodsProps?: UseFormReturn<z.TypeOf<T>, any, undefined>;
}

export const FormWrapper = <T extends ZodType>({
  children = <></>,
  formSchema,
  defaultValues,
  formMethodsProps,
}: FormWrapperProps<T>) => {
  const formMethods = formMethodsProps ? formMethodsProps : useCustomForm(formSchema, defaultValues);

  if (!formMethods) return null;

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};
